import { API } from './API.js';
import axios from 'axios';

const url = API + '/cellars/';
const debug = false;

class Cellars {
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(winery=> ({
                        ...winery,
                        name: winery.name
                    }))
                );
                if (debug) console.log("Cellars.get: data = ", data)
            } catch(err) {
                reject(err);
            }
        })
    }

    // get one winery
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                if (debug) console.log('Cellars.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('Cellars.getone: ',error)
            })
    }

    static create(postdata) {
        if (debug) console.log('Cellars.create: postdata = ',postdata)
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('Cellars.create: response = ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('Cellars.create: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('Cellars.update: id=',id)
        if (debug) console.log('Cellars.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('Cellars.update: ',response)
                return id
            })
            .catch(error => {
                console.log('Cellars.update: ',error)
            })
    }

    static delete(id) {
        return axios.delete(`${url}${id}`)
    } 
}

export default Cellars